import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function DeleteModal({
  createTextArea,
  deleteTransaction,
  formData,
  updateList,
  setFormData,
  id,
  updating,
  getTransactionList,
  showTransaction,
  data,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      remarks: formData.remarks,
      status: _.get(data, 'attributes.transaction_status'),
    };

    const param = {
      module_type: 'T_BPLS',
      transaction_type: 'RENEWAL',
      sort_by: 'asc',
    };

    deleteTransaction(id, args, () => {
      setModal({ isOpen: false });

      getTransactionList(param, (response) => {
        const ids = _.get(response, 'data.0.id');
        showTransaction(ids);
      });
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createTextArea(
              {
                key: 'remarks',
                label: `Are you sure, you want to delete this transaction?`,
              },
              { maxLength: '500', rows: '15' }
            )}
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Delete`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

DeleteModal.propTypes = {
  createTextArea: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  deleteTransaction: PropTypes.instanceOf(Function).isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_BUSINESS_TRANSACTION) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(DeleteModal);
